import React from "react";
import appMarkTransparent from "../assets/brand/chara-app-mark-transparent-v1.png";
import mascotJumpTransparent from "../assets/brand/chara-mascot-jump-transparent-v1.png";
import mascotRunTransparent from "../assets/brand/chara-mascot-run-transparent-v1.png";
import mascotWaveTransparent from "../assets/brand/chara-mascot-wave-transparent-v1.png";
import wordmarkRunWithJoy from "../assets/brand/chara-wordmark-run-with-joy-v3.png";
const DEFAULT_SUBTITLE = "Run with Joy";
const mascotSprites = {
  wave: mascotWaveTransparent,
  jump: mascotJumpTransparent,
  run: mascotRunTransparent,
};

export function BrandMark({ size = 52, compact = false }) {
  return (
    <div
      className={`brand-mark ${compact ? "compact" : ""}`}
      style={{ "--brand-mark-size": `${size}px` }}
      aria-hidden="true"
    >
      <img src={appMarkTransparent} alt="" />
    </div>
  );
}

export function BrandWordmark({ subtitle = DEFAULT_SUBTITLE, compact = false }) {
  if (subtitle === DEFAULT_SUBTITLE || subtitle === "") {
    const classes = ["brand-wordmark-art", compact ? "brand-wordmark-art--compact" : ""].filter(Boolean).join(" ");
    return <img className={classes} src={wordmarkRunWithJoy} alt="Chara. Run with Joy." />;
  }

  return (
    <div className={`brand-lockup ${compact ? "compact" : ""}`}>
      <BrandMark size={compact ? 42 : 68} compact={compact} />
      <div className="brand-wordmark-block">
        <div className="brand-wordmark-text">chara</div>
        {subtitle ? <div className="brand-subtitle brand-subtitle--fallback">{subtitle}</div> : null}
      </div>
    </div>
  );
}

export function MascotSprite({ variant = "wave", className = "", alt = "Chara mascot" }) {
  const sprite = mascotSprites[variant] || mascotSprites.wave;
  const classes = ["mascot-sprite", `mascot-sprite--${variant}`, className].filter(Boolean).join(" ");

  return <img className={classes} src={sprite} alt={alt} />;
}

export function HorizonArtwork() {
  return (
    <div className="horizon-artwork" aria-hidden="true">
      <div className="horizon-glow horizon-glow-a" />
      <div className="horizon-glow horizon-glow-b" />
      <div className="horizon-badge">A coach that adapts</div>
      <div className="horizon-image-shell">
        <img className="horizon-image" src={appMarkTransparent} alt="" />
      </div>
      <MascotSprite variant="run" alt="" className="horizon-mascot" />
      <div className="horizon-copy-card">
        <strong>Real coaching moments happen in conversation.</strong>
        <p>Text Chara when the week changes and get a clear next step with a reason behind it.</p>
      </div>
      <div className="trail-lines">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export function MascotPanel({ quote = "" }) {
  return (
    <div className="mascot-panel" aria-hidden="true">
      <div className="mascot-orbit mascot-orbit-a" />
      <div className="mascot-orbit mascot-orbit-b" />
      <div className="mascot-image-frame">
        <MascotSprite variant="run" className="mascot-image mascot-image--sprite" alt="" />
      </div>
      {quote ? <div className="mascot-quote-overlay">{quote}</div> : null}
    </div>
  );
}
